





































import { emit } from 'process'
import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

@Component
export default class AppTabs extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly items!: string[]
  @Prop({ type: Number, default: 0 }) readonly value!: number
  @Prop({ type: String, default: 'c-tabs' }) readonly className!: number
  @Prop({ type: Array, default: () => [] }) readonly additions!: string[]
  @Prop({ type: Array, default: () => [] }) readonly tabAddBorder: Boolean[] | undefined | null
  @Prop({ type: Boolean, default: false }) readonly isShowMoreBtn: Boolean | null | undefined

  model = 0
  isActiveMore = false
  menu = false

  mounted () {
    this.model = this.value
  }

  @Watch('value')
  onValueChanged (val: number) {
    this.model = this.value
  }

  @Emit('click')
  @Emit('input')
  valueChangedHandler (index: number) {
    this.model = index
    return index
  }
  @Emit('getAccount')
  handleClick () {
    this.isActiveMore = true
  }

  @Watch('isActiveMore')
  onIsActiveMoreChanged () {
    if (this.isActiveMore) {
      this.handleClick()
    }
  }
}
